import React from "react";
import { inject, observer } from "mobx-react";
import Store from "../../stores/NewExistingOwnerStore";
import { OwnerNav } from "./";
import { ModelPageUrl } from "../../utils/ModelUrls";
import { UserStatus } from "../../models/NewExistingOwner";

interface IProps {
  store?: Store;
}

interface IState {}

@inject("store")
@observer
class Thanks extends React.Component<IProps, IState> {
  state: IState = {};

  get store(): Store {
    return this.props.store;
  }

  componentDidMount() {
    const { userStatus, modelName, email, phone, postcode } = this.store;
    const _stage =
      userStatus === UserStatus.New
        ? "register your Subaru"
        : "update your details";
    setTimeout(async function () {
      const _userData = {
        emailHashed: await window["digestStringSHA256"](email),
        phoneHashed: await window["digestStringSHA256"](phone),
        postcode: postcode,
      };
      const _userFormData = await window["encryptUserData"]({
        encryptedEmail: email,
        encryptedPhone: phone,
      });
      window["pushDigitalData"](
        {
          event: "_formNavigate",
          form: {
            name: _stage,
            stage: "submitted",
            details: {
              vehicleSelected: [
                {
                  make: "subaru",
                  model: modelName,
                },
              ],
            },
          },
          user: { ..._userData, ..._userFormData },
        },
        true
      );
    }, 0);
  }

  render() {
    return (
      <section className=" text-center">
        <OwnerNav active={3} />
        <div className="container pageSection__content">
          <div className="row">
            <div className="col-xs-12 col-md-8 col-md-offset-2">
              <h2 className="h1">thanks!</h2>
              <p>
                We'll get in touch with you ASAP to confirm your registration.
                In the meantime, head over to Owner's Benefits to see what you
                get for being part of the Subaru family.
              </p>
              <p>&nbsp;</p>

              <a
                className="btn btn--primary"
                href={`${ModelPageUrl(
                  this.store.modelName || "xv"
                )}/owners/benefits`}
              >
                Go to Owner's Benefits
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Thanks;
